export const navLicensee = {
  items: [
    {
      name: "Dashboard",
      url: "/dashboard",
      icon: "icon-grid",
    },
    {
      name: "Apartments",
      url: "/apartments",
      icon: "fa fa-building",
    },
    {
      name: "Alerts",
      url: "/alerts",
      icon: "fa-solid fa-exclamation-triangle",
    },
    {
      name: "Purchase",
      url: "/purchases",
      icon: "fa-solid fa-shopping-cart",
    },
    {
      name: "Invoice",
      url: "/invoice",
      icon: "fa fa-inr",
    },

    {
      name: "Settings",
      url: "/settings",
      icon: "fa-solid fa-gear",
    },
    // {
    //   name: "Rwamembers",
    //   url: "/rwamembers",
    //   icon: "icon-bell",
    // },

    // {
    //   name: "Support",
    //   url: "/support",
    //   icon: "icon-support",
    // },
    // {
    //   name: "Approved Residents",
    //   url: "/approvedresidents",
    //   icon: "icon-user",
    // },
    // { name: "Onboarding 1", url: "/Onboarding1", icon: "icon-bulb" },
    // {
    //   name: "OnboardingResidents",
    //   url: "/onboardingResidents",
    //   icon: "icon-support",
    // },
    // {
    //   name: "onboarding2",
    //   url: "/onboarding2",
    //   icon: "icon-support",
    // },
    // {
    //   name: "Consumption",
    //   url: "/consumption",
    //   icon: "icon-support",
    // },
    // {
    //   name: "Alerts",
    //   url: "/alerts",
    //   icon: "icon-bell",
    // },
    // {
    //   name: "Collections",
    //   url: "/collections",
    //   icon: "icon-bell",
    // },
    // {
    //   name: "Control",
    //   url: "/control",
    //   icon: "fa fa-toggle-on",
    // },
    // {
    //   name: "Residents",
    //   url: "/residents",
    //   icon: "icon-bell",
    // },
    // {
    //   name: "App User",
    //   url: "/appuser",
    //   icon: "icon-bell",
    // },
    // {
    //   name: "RWA Members",
    //   url: "/rwamembers",
    //   icon: "icon-bell",
    // },
  ],
};

export const navResidents = {
  items: [
    //  {
    //     name: "Residents",
    //     url: "/residents",
    //     icon: "icon-bell",
    //   },
    {
      name: "OnboardingResidents",
      url: "/onboardingResidents",
      icon: "icon-support",
    },
    {
      name: "Approved Residents",
      url: "/approvedresidents",
      icon: "icon-user",
    },
  ],
};
